import styled from 'styled-components/macro';

export const StyledContent = styled.div`
  width: 100%;
  height: 100%;
  position: relative;

  .infoValueCell {
    white-space: normal;
    overflow-y: auto;
    word-break: break-word;
    line-height: 1.3;
    max-height: 100px;
  }
`;

export const StyledEditLink = styled.div`
  display: flex;
  flex-direction: column;
  float: right;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 40px;
`;
